/* Dirksen Scooters — winkelwagenlade
   Vanilla JS, defer geladen.

   De lade schuift van rechts in zodra er iets is toegevoegd, en vervangt de
   regel "Toegevoegd aan je winkelwagen" boven de knop.

   Alles wat de lade toont komt uit Liquid: na elke wijziging wordt de sectie
   opnieuw opgehaald met de Section Rendering API en wordt de inhoud vervangen.
   Zo gaat elk bedrag door de money-filter en staat er nooit een prijs die in
   JavaScript is opgemaakt.

   Zonder dit script gebeurt er niets bijzonders: het winkelwagenicoon houdt
   zijn link naar /cart en het formulier op de productpagina post gewoon. */

(function () {
  'use strict';

  var OPEN_CLASS = 'dk-drawer-cart--open';
  var LOCK_CLASS = 'dk-scroll-lock';

  function api(root) {
    var sectionId = root.dataset.dkSection;
    var panel = root.querySelector('.dk-drawer-cart__panel');
    var busy = false;
    var lastFocus = null;

    /* Openen en sluiten ------------------------------------------------- */

    function isOpen() {
      return root.getAttribute('aria-hidden') === 'false';
    }

    function open() {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      root.setAttribute('aria-hidden', 'false');
      root.classList.add(OPEN_CLASS);
      document.documentElement.classList.add(LOCK_CLASS);
      focusFirst();
    }

    function close() {
      if (!isOpen()) return;
      root.setAttribute('aria-hidden', 'true');
      root.classList.remove(OPEN_CLASS);
      document.documentElement.classList.remove(LOCK_CLASS);
      // Terug naar waar de bezoeker was, anders staat de focus nergens.
      if (lastFocus && lastFocus.isConnected) lastFocus.focus();
    }

    function focusables() {
      return Array.prototype.slice
        .call(panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.offsetParent !== null || el.getClientRects().length > 0; });
    }

    function focusFirst() {
      var first = panel.querySelector('.dk-drawer-cart__close') || focusables()[0];
      if (first) first.focus();
    }

    /* De focus blijft binnen de lade zolang die open is: daarbuiten is de
       pagina niet te gebruiken en tabben zou de bezoeker eruit laten lopen. */
    function trap(event) {
      if (event.key !== 'Tab' || !isOpen()) return;
      var list = focusables();
      if (list.length === 0) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* Bijwerken --------------------------------------------------------- */

    function optionKeysOf(line) {
      var group = line.dataset.dkGroup;
      var title = line.dataset.dkTitle;
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-dk-line]'))
        .filter(function (candidate) {
          if (!candidate.dataset.dkBelongsTo) return false;
          if (group && candidate.dataset.dkGroup) return candidate.dataset.dkGroup === group;
          if (group || candidate.dataset.dkGroup) return false;
          return candidate.dataset.dkBelongsTo === title;
        })
        .map(function (option) { return option.dataset.dkKey; })
        .filter(Boolean);
    }

    /* Wijzigingen gaan op regelsleutel, niet op positie: een positionele reeks
       moet precies zo lang zijn als de winkelwagen regels heeft en schuift op
       zodra er een regel verdwijnt. Zelfde aanpak als op de winkelwagenpagina. */
    function send(changes) {
      if (busy) return Promise.resolve();
      if (Object.keys(changes).length === 0) return Promise.resolve();
      busy = true;
      root.setAttribute('aria-busy', 'true');

      return fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: changes,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('winkelwagen bijwerken mislukte');
          return response.json();
        })
        .then(function (cart) {
          replaceWith(cart.sections && cart.sections[sectionId]);
          syncHeader(cart);
        })
        .catch(function () {
          // Bij twijfel de winkelwagenpagina; daar klopt het beeld zeker.
          window.location.href = window.routes.cart_url;
        })
        .then(function () {
          busy = false;
          root.removeAttribute('aria-busy');
        });
    }

    function replaceWith(html) {
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('[data-dk-cart-drawer]');
      if (!fresh) return;
      var wasOpen = isOpen();
      panel.innerHTML = fresh.querySelector('.dk-drawer-cart__panel').innerHTML;
      panel = root.querySelector('.dk-drawer-cart__panel');
      if (wasOpen) focusFirst();
    }

    /* Teller en totaal in de header komen uit dezelfde sectie als altijd, zodat
       ook daar de opmaak uit Liquid komt. */
    function syncHeader(cart) {
      var count = document.querySelector('[data-dk-cart-count]');
      if (count && cart && typeof cart.item_count === 'number') {
        count.textContent = cart.item_count;
        count.classList.toggle('is-empty', cart.item_count === 0);
      }
      fetch(window.location.pathname + '?sections=header')
        .then(function (response) { return response.json(); })
        .then(function (data) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = data.header;
          var freshTotal = wrapper.querySelector('.dk-header__cart-total');
          var current = document.querySelector('.dk-header__cart-total');
          if (freshTotal && current) current.textContent = freshTotal.textContent;
        })
        .catch(function () { /* de teller staat al goed */ });
    }

    /* Alleen de sectie opnieuw ophalen, zonder iets te wijzigen. Gebruikt nadat
       de productpagina iets heeft toegevoegd. */
    function refresh() {
      return fetch(window.location.pathname + '?sections=' + sectionId)
        .then(function (response) { return response.json(); })
        .then(function (data) { replaceWith(data[sectionId]); })
        .catch(function () { /* dan blijft de vorige inhoud staan */ });
    }

    /* Gebeurtenissen ---------------------------------------------------- */

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-dk-drawer-close]')) {
        event.preventDefault();
        close();
        return;
      }

      var step = event.target.closest('[data-dk-qty-step]');
      if (step) {
        event.preventDefault();
        var line = step.closest('[data-dk-line]');
        var value = line.querySelector('.dk-drawer-cart__qty-value');
        var next = (parseInt(value.textContent, 10) || 0) + parseInt(step.dataset.dkQtyStep, 10);
        if (next < 0) next = 0;

        var changes = {};
        changes[step.dataset.dkKey] = next;
        // Op nul is hetzelfde als verwijderen, dus de opties gaan mee.
        if (next === 0) {
          optionKeysOf(line).forEach(function (key) { changes[key] = 0; });
        }
        send(changes);
        return;
      }

      var remove = event.target.closest('[data-dk-drawer-remove]');
      if (remove) {
        event.preventDefault();
        var target = remove.closest('[data-dk-line]');
        var wipe = {};
        wipe[remove.dataset.dkKey] = 0;
        if (!target.dataset.dkBelongsTo) {
          optionKeysOf(target).forEach(function (key) { wipe[key] = 0; });
        }
        send(wipe);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) close();
      trap(event);
    });

    return { open: open, close: close, refresh: refresh, isOpen: isOpen };
  }

  function init() {
    var root = document.querySelector('[data-dk-cart-drawer]');
    if (!root || root.dataset.dkReady === '1') return;
    root.dataset.dkReady = '1';
    window.dkCartDrawer = api(root);

    /* Het winkelwagenicoon in de header opent de lade in plaats van naar de
       pagina te gaan. De link blijft staan voor het geval dit script niet
       draait. */
    document.addEventListener('click', function (event) {
      var cartLink = event.target.closest('.dk-header__cart');
      if (!cartLink || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

      // Op de winkelwagenpagina zelf blijft het een link: een lade over
      // dezelfde inhoud heen helpt niemand.
      if (window.location.pathname.indexOf(window.routes.cart_url) === 0) return;

      event.preventDefault();
      window.dkCartDrawer.refresh().then(function () { window.dkCartDrawer.open(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
